import React from "react";
import { useTranslation } from "react-i18next";
import Eyebrow from "../../atoms/Eyebrow/Eyebrow.styled";
import Icon, { IconName } from "../../atoms/Icon/Icon.component";
import AttendeeDemo from "../../molecules/AttendeeDemo/AttendeeDemo.component";
import { getCollectionFeaturesTranslated } from "../../../constants/collection";
import { newLineText } from "../../../utils/utils";
import {
  CollectionCopy,
  CollectionGrid,
  CollectionLead,
  CollectionSection,
  CollectionTitle,
  CollectionVisual,
  FeatureDescription,
  FeatureLine,
  FeatureTitle,
} from "./Collection.styled";

const Collection = () => {
  const { t } = useTranslation();
  const features = getCollectionFeaturesTranslated(t);

  return (
    <CollectionSection aria-labelledby="collection-title">
      <CollectionGrid>
        <CollectionVisual>
          <AttendeeDemo />
        </CollectionVisual>
        <CollectionCopy>
          <Eyebrow>{t("landing.collection.eyebrow")}</Eyebrow>
          <CollectionTitle id="collection-title">
            {newLineText(t("landing.collection.title")).map((line) => (
              <span key={line}>{line}</span>
            ))}
          </CollectionTitle>
          <CollectionLead>{t("landing.collection.lead")}</CollectionLead>
          {features.map((feature) => (
            <FeatureLine key={feature.id}>
              <Icon name={feature.icon as IconName} />
              <div>
                <FeatureTitle>{feature.title}</FeatureTitle>
                <FeatureDescription>{feature.description}</FeatureDescription>
              </div>
            </FeatureLine>
          ))}
        </CollectionCopy>
      </CollectionGrid>
    </CollectionSection>
  );
};

export default Collection;
